// FOOTER index
import './Footer.css';

export default function Footer(){
    return (
        <footer className="footer content-size">
            <div className="footer__container">
                <p className="footer__text">
                    <a href="../../files/policy.pdf">Політика конфіденційності</a>
                </p>
                <p className="footer__text">
                    Усі права захищені ТОВ “ПРОЛЕГО”
                </p>
            </div>
        </footer>
    )
}